// oxlint-disable unicorn/no-useless-spread
import { createDateInNorwegianTime } from '../../../services/new-utils.ts';

export const SUMMER_JUNE_2024_COMPETITION_END_DATE = createDateInNorwegianTime(
  ...[2024, 7, 1, 0, 0, 0],
);

export const SUMMER_JULY_2024_COMPETITION_END_DATE = createDateInNorwegianTime(
  ...[2024, 8, 15, 23, 59, 59],
);
